import {Button, Stack} from '@mui/material'
import {withTranslation, WithTranslation} from 'react-i18next'
import TimelineEventTemplate from 'web-common/views/timeline/TimelineEventTemplate'
import {AssistantEventProducer} from '../AssistantEventProducer'
import {ChatAdapter} from '@fnd/timeline'
import {Like1} from 'iconsax-reactjs'

interface ConfirmCreateDemandProps {
  buttonLabel: string
  position: 'flex-start' | 'center' | 'flex-end'
  producer: AssistantEventProducer
}

interface ConfirmCreateDemandState {
  loading: boolean
}

interface InternalProps extends ConfirmCreateDemandProps, WithTranslation {}

class ConfirmCreateDemand extends TimelineEventTemplate<
  InternalProps,
  ConfirmCreateDemandState
> {
  state: ConfirmCreateDemandState = {
    loading: false
  }

  handleOnConfirm = async () => {
    this.setState({loading: true})

    await this.props.producer.createEvent({
      message:
        this.props.buttonLabel ?? this.props.t('fnd-assistant-action-confirm'),
      adapterId: ChatAdapter.id,
      data: {
        metadata: {
          action: 'CREATE_DEMAND'
        }
      }
    })

    this.setState({loading: false})
    this.props.producer.actionManager.removeConfirmCreateDemand()
  }

  render() {
    const {buttonLabel, position, producer} = this.props
    const {loading} = this.state

    return (
      <Stack spacing={2} alignItems={position} marginTop={1}>
        <Button
          startIcon={<Like1 />}
          variant="contained"
          color="primary"
          size="medium"
          sx={{borderRadius: 3}}
          disabled={loading || producer.hasDemandId()}
          onClick={this.handleOnConfirm}
        >
          {buttonLabel}
        </Button>
      </Stack>
    )
  }
}

export default withTranslation()(ConfirmCreateDemand)
